import type { CustomDisclaimerService } from '../types/customDisclaimers';
import { CustomDisclaimerApiService } from './customDisclaimerApiService';

export const customDisclaimerService: CustomDisclaimerService = new CustomDisclaimerApiService();
